import PNotify from 'pnotify/dist/es/PNotify.js';

PNotify.defaults.styling = 'bootstrap4';

export class Utils {
    /**
     * Helper function to display notifications.
     * It receives an object with message properties
     *
     * @param $message
     */
    static notify($message) {
        PNotify.alert({
            title: $message.title,
            text: $message.message,
            type: $message.type,
            modules: {
                Buttons: {
                    closer: true,
                    closerHover: true,
                    sticker: true,
                    stickerHover: true,
                    labels: {close: "Close", stick: "Stick", unstick: "Unstick"}
                }
            }
        });
    }

    static isNumber(n) {
        return typeof n === 'number' && !isNaN(n) && n < Infinity && n > -Infinity;
    }

    static numberFormat(number, decimals = 2, decimalPoint = '.', thousandsSep = ',') {
        number = +number || 0;
        decimals = +decimals;

        var origDec = (number.toString().split('.')[1] || '').split('e')[0].length,
            strinteger,
            thousands,
            ret,
            roundedNumber,
            exponent = number.toString().split('e'),
            fractionDigits;

        if (decimals === -1) {
            // Preserve decimals. Not huge numbers (#3793).
            decimals = Math.min(origDec, 20);
        } else if (!Utils.isNumber(decimals)) {
            decimals = 2;
        } else if (decimals && exponent[1] && exponent[1] < 0) {
            // Expose decimals from exponential notation (#7042)
            fractionDigits = decimals + +exponent[1];
            if (fractionDigits >= 0) {
                // remove too small part of the number while keeping the notation
                exponent[0] = (+exponent[0]).toExponential(fractionDigits)
                    .split('e')[0];
                decimals = fractionDigits;
            } else {
                // fractionDigits < 0
                exponent[0] = exponent[0].split('.')[0] || 0;

                if (decimals < 20) {
                    // use number instead of exponential notation (#7405)
                    number = (exponent[0] * Math.pow(10, exponent[1]))
                        .toFixed(decimals);
                } else {
                    // or zero
                    number = 0;
                }
                exponent[1] = 0;
            }
        }

        // Add another decimal to avoid rounding errors of float numbers. (#4573)
        // Then use toFixed to handle rounding.
        roundedNumber = (
            Math.abs(exponent[1] ? exponent[0] : number) +
            Math.pow(10, -Math.max(decimals, origDec) - 1)
        ).toFixed(decimals);

        // A string containing the positive integer component of the number
        strinteger = String(parseInt(roundedNumber));

        // Leftover after grouping into thousands. Can be 0, 1 or 3.
        thousands = strinteger.length > 3 ? strinteger.length % 3 : 0;

        // Start building the return
        ret = number < 0 ? '-' : '';

        // Add the leftover after grouping into thousands. For example, in the
        // number 42 000 000, this line adds 42.
        ret += thousands ? strinteger.substr(0, thousands) + thousandsSep : '';

        // Add the remaining thousands groups, joined by the thousands separator
        ret += strinteger
            .substr(thousands)
            .replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep);

        // Add the decimal point and the decimal component
        if (decimals) {
            // Get the decimal component
            ret += decimalPoint + roundedNumber.slice(-decimals);
        }

        if (exponent[1] && +ret !== 0) {
            ret += 'e' + exponent[1];
        }

        return ret;
    }
}
